// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* 색상 팔레트 */
  --primary-color: #667eea;
  --primary-hover: #5a6fd8;
  --primary-light: #f8f9ff;
  
  --secondary-color: #6c757d;
  --secondary-hover: #5a6268;
  
  --success-color: #28a745;
  --success-hover: #218838;
  --success-light: #d4edda;
  --success-border: #c3e6cb;
  
  --danger-color: #dc3545;
  --danger-hover: #c82333;
  --danger-light: #f8d7da;
  --danger-border: #f5c6cb;
  
  --warning-color: #ffc107;
  --warning-light: #fff3cd;
  --warning-border: #ffeaa7;
  
  --info-color: #17a2b8;
  --info-light: #d1ecf1;
  --info-border: #bee5eb;
  
  /* 중성 색상 */
  --white: #ffffff;
  --gray-50: #f8f9fa;
  --gray-100: #e9ecef;
  --gray-200: #dee2e6;
  --gray-300: #ced4da;
  --gray-400: #adb5bd;
  --gray-500: #6c757d;
  --gray-600: #495057;
  --gray-700: #343a40;
  --gray-800: #212529;
  --gray-900: #000000;
  
  /* 텍스트 색상 */
  --text-primary: #333333;
  --text-secondary: #666666;
  --text-muted: #999999;
  --text-light: #cccccc;
  
  /* 배경 색상 */
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --bg-tertiary: #f5f5f5;
  
  /* 테두리 */
  --border-color: #e1e5e9;
  --border-light: #f0f0f0;
  --border-radius: 4px;
  --border-radius-lg: 8px;
  --border-radius-xl: 12px;
  
  /* 그림자 */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 8px 16px rgba(0, 0, 0, 0.1);
  
  /* 간격 */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
  
  /* 폰트 크기 */
  --font-xs: 0.75rem;
  --font-sm: 0.875rem;
  --font-base: 1rem;
  --font-lg: 1.125rem;
  --font-xl: 1.25rem;
  --font-2xl: 1.5rem;
  --font-3xl: 1.875rem;
  
  /* 폰트 두께 */
  --font-normal: 400;
  --font-medium: 500;
  --font-semibold: 600;
  --font-bold: 700;
  
  /* 전환 효과 */
  --transition-fast: 0.15s ease;
  --transition-base: 0.2s ease;
  --transition-slow: 0.3s ease;
  
  /* Z-인덱스 */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,0BAA0B;EAC1B,0BAA0B;;EAE1B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;EAEzB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;EAEzB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;;EAEtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;;EAErB,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,QAAQ;EACR,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;;EAExB,QAAQ;EACR,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;;EAE1C,OAAO;EACP,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;;EAEhB,UAAU;EACV,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;;EAE5B,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[":root {\r\n  /* 색상 팔레트 */\r\n  --primary-color: #667eea;\r\n  --primary-hover: #5a6fd8;\r\n  --primary-light: #f8f9ff;\r\n  \r\n  --secondary-color: #6c757d;\r\n  --secondary-hover: #5a6268;\r\n  \r\n  --success-color: #28a745;\r\n  --success-hover: #218838;\r\n  --success-light: #d4edda;\r\n  --success-border: #c3e6cb;\r\n  \r\n  --danger-color: #dc3545;\r\n  --danger-hover: #c82333;\r\n  --danger-light: #f8d7da;\r\n  --danger-border: #f5c6cb;\r\n  \r\n  --warning-color: #ffc107;\r\n  --warning-light: #fff3cd;\r\n  --warning-border: #ffeaa7;\r\n  \r\n  --info-color: #17a2b8;\r\n  --info-light: #d1ecf1;\r\n  --info-border: #bee5eb;\r\n  \r\n  /* 중성 색상 */\r\n  --white: #ffffff;\r\n  --gray-50: #f8f9fa;\r\n  --gray-100: #e9ecef;\r\n  --gray-200: #dee2e6;\r\n  --gray-300: #ced4da;\r\n  --gray-400: #adb5bd;\r\n  --gray-500: #6c757d;\r\n  --gray-600: #495057;\r\n  --gray-700: #343a40;\r\n  --gray-800: #212529;\r\n  --gray-900: #000000;\r\n  \r\n  /* 텍스트 색상 */\r\n  --text-primary: #333333;\r\n  --text-secondary: #666666;\r\n  --text-muted: #999999;\r\n  --text-light: #cccccc;\r\n  \r\n  /* 배경 색상 */\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #f8f9fa;\r\n  --bg-tertiary: #f5f5f5;\r\n  \r\n  /* 테두리 */\r\n  --border-color: #e1e5e9;\r\n  --border-light: #f0f0f0;\r\n  --border-radius: 4px;\r\n  --border-radius-lg: 8px;\r\n  --border-radius-xl: 12px;\r\n  \r\n  /* 그림자 */\r\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  --shadow-xl: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  \r\n  /* 간격 */\r\n  --spacing-xs: 0.25rem;\r\n  --spacing-sm: 0.5rem;\r\n  --spacing-md: 1rem;\r\n  --spacing-lg: 1.5rem;\r\n  --spacing-xl: 2rem;\r\n  --spacing-2xl: 3rem;\r\n  \r\n  /* 폰트 크기 */\r\n  --font-xs: 0.75rem;\r\n  --font-sm: 0.875rem;\r\n  --font-base: 1rem;\r\n  --font-lg: 1.125rem;\r\n  --font-xl: 1.25rem;\r\n  --font-2xl: 1.5rem;\r\n  --font-3xl: 1.875rem;\r\n  \r\n  /* 폰트 두께 */\r\n  --font-normal: 400;\r\n  --font-medium: 500;\r\n  --font-semibold: 600;\r\n  --font-bold: 700;\r\n  \r\n  /* 전환 효과 */\r\n  --transition-fast: 0.15s ease;\r\n  --transition-base: 0.2s ease;\r\n  --transition-slow: 0.3s ease;\r\n  \r\n  /* Z-인덱스 */\r\n  --z-dropdown: 1000;\r\n  --z-sticky: 1020;\r\n  --z-fixed: 1030;\r\n  --z-modal-backdrop: 1040;\r\n  --z-modal: 1050;\r\n  --z-popover: 1060;\r\n  --z-tooltip: 1070;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
